webpackJsonp([13875959300118],{

/***/ 1396:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CouponProductInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":"false","description":null,"name":"autoApply","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"productId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-coupon-product-input-27a440b3d63f38a494ba.js